import React, { useEffect } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AppState, RootState, Dispatcher } from 'AppTypes'

import { LoadingSpinner } from '@share/components'
import { toggleGlobalLoading } from '@app/state_management/actions'
import { useDidMountRef } from '@utils'

type Props = {
  appState: AppState
  dispatch: Dispatcher
}

const Analytics: React.FC<Props> = ({
  appState,
  dispatch
}) => {
  const isMounted = useDidMountRef()

  if (!isMounted) {
    dispatch(toggleGlobalLoading(true))

    setTimeout(() => {
      dispatch(toggleGlobalLoading(false))
    }, 1000)
  }

  const { t } = useTranslation()
  // V.A IS IN PROGRESS
  return (
    <div className="main-content p-0">
      <LoadingSpinner />
      <ul className="nav nav-tabs" id="StoreInformationTab" role="tablist">
        <li className="nav-item">
          <a className="nav-link active" id="StoreInformation-BasicInformation-tab" data-toggle="tab" href="#StoreInformation-BasicInformation" role="tab" aria-controls="BasicInformation" aria-selected="true">ユーザー</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="StoreInformation-PriceRangeCategory-tab" data-toggle="tab" href="#StoreInformation-PriceRangeCategory" role="tab" aria-controls="PriceRangeCategory" aria-selected="false">外部リンク</a>
        </li>
      </ul>
      <div className="tab-content" id="StoreInformationTabContent">
        {/* <!-- Store information - basic information --> */}
        <div className="tab-pane fade show active" id="StoreInformation-BasicInformation" role="tabpanel" aria-labelledby="StoreInformation-BasicInformation-tab">
          <h3 className="mb-4">
            <img src="/assets/img/shop-ui_icon_access-red.png" alt="" />ユーザー
          </h3>
          <div className="chart-js">
            <img src="/assets/img/chart-img.jpg" alt="" width="100%" />
          </div>
        </div>
        {/* <!-- End Store information - basic information --> */}

        {/* <!-- Store information - price range category --> */}
        <div className="tab-pane fade" id="StoreInformation-PriceRangeCategory" role="tabpanel" aria-labelledby="StoreInformation-PriceRangeCategory-tab">
          <h3 className="mb-4">
            <img src="/assets/img/shop-ui_icon_access-red.png" alt="" />
            外部リンク
          </h3>
          <div className="chart-js">
            <img src="/assets/img/chart-img-2.jpg" alt="" width="100%" />
          </div>
        </div>
        {/* <!-- EndStore information - price range category --> */}
      </div>
    </div>
  )
}

export default connect((state: RootState) => ({
  appState: state.app
}))(Analytics)
